import { participantRemarks, participantRole } from "ApiMaxLength";
import { HookFormComboBox } from "components/HookForm/HookFormComboBox";
import { HookFormPeoplePicker } from "components/HookForm/HookFormPeoplePicker";
import { HookFormSelect } from "components/HookForm/HookFormSelect";
import { HookFormTextArea } from "components/HookForm/HookFormTextArea";
import { HookFormToggle } from "components/HookForm/HookFormToggle";
import { InlineSpinner } from "components/InlineSpinner";
import {
  ResourceKeys,
  useEditParticipant,
  useParticipantRoles,
  useParticipantStatuses,
  useTranslations,
} from "providers";
import React from "react";

export const EditParticipantForm: React.FC = () => {
  const i18n = useTranslations();
  const { participantRoles } = useParticipantRoles();
  const { participantStatuses } = useParticipantStatuses();
  const { form, isLoading } = useEditParticipant();
  const { control } = form;

  if (isLoading) {
    return <InlineSpinner text={i18n.Participant_Loading_EditForm} />;
  }

  if (!control) {
    return null;
  }

  return (
    <>
      <HookFormPeoplePicker
        name="user"
        control={control}
        label={ResourceKeys.Participant_User_Title}
        contextHelp={ResourceKeys.Participant_User_Description}
        required
      />

      <HookFormComboBox
        name="role"
        control={control}
        label={ResourceKeys.Participant_Role_Title}
        contextHelp={ResourceKeys.Participant_Role_Description}
        maxLength={participantRole}
        options={participantRoles}
        minInputLength={0}
      />

      <HookFormSelect
        name="status"
        control={control}
        label={ResourceKeys.Participant_Status_Title}
        contextHelp={ResourceKeys.Participant_Status_Description}
        required
        options={participantStatuses}
      />

      <HookFormTextArea
        name="remarks"
        control={control}
        label={ResourceKeys.Participant_Remarks_Title}
        contextHelp={ResourceKeys.Participant_Remarks_Description}
        maxLength={participantRemarks}
      />

      <HookFormToggle
        name="canSeeConfidential"
        control={control}
        label={ResourceKeys.Participant_CanSeeConfidential_Title}
        contextHelp={ResourceKeys.Participant_CanSeeConfidential_Description}
      />
    </>
  );
};
